import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

/* eslint-disable no-new */
const store = new Vuex.Store({
  state: {
    petProfileEditDialog: 0,
    petProfileDeleteDialog: 0
  },
  mutations: {
    triggerPetProfileEditDialog(state) {
      state.petProfileEditDialog++;
    },
    triggerPetProfileDeleteDialog(state) {
      state.petProfileDeleteDialog++;
    }
  }
});

export default store;
